// routes
import { PATH_DASHBOARD } from "../../routes/paths";
// components
import Label from "../../core/components/Label";
import SvgIconStyle from "../../core/components/SvgIconStyle";
import path from "path";

// ----------------------------------------------------------------------

const getIcon = (name: string) => (
  <SvgIconStyle
    src={`/icons/navbar/${name}.svg`}
    sx={{ width: "100%", height: "100%" }}
  />
);

const ICONS = {
  blog: getIcon("ic_blog"),
  cart: getIcon("ic_cart"),
  chat: getIcon("ic_chat"),
  mail: getIcon("ic_mail"),
  user: getIcon("ic_user"),
  kanban: getIcon("ic_kanban"),
  banking: getIcon("ic_banking"),
  calendar: getIcon("ic_calendar"),
  ecommerce: getIcon("ic_ecommerce"),
  analytics: getIcon("ic_analytics"),
  dashboard: getIcon("ic_dashboard"),
  booking: getIcon("ic_booking"),
};

const sidebarConfigUser = [
  {
    subheader: "Management",
    items: [
      {
        title: "Dosyalar",
        path: PATH_DASHBOARD.general.app,
        icon: ICONS.dashboard,
      },
      {
        title: "Raporlar",
        path: PATH_DASHBOARD.reports.root,
        icon: ICONS.chat,
        children: [
          {
            title: "Kullanım",
            path: PATH_DASHBOARD.reports.usage,
          },
          {
            title: "İstatistik",
            path: PATH_DASHBOARD.reports.statistic,
          },
          {
            title: "Erişim denetimi",
            path: PATH_DASHBOARD.reports.audit,
          },
        ],
      },
      {
        title: "API Anahtarları",
        path: PATH_DASHBOARD.general.apiKeys,
        icon: ICONS.mail,
      },
    ],
  },
];

const sidebarConfigAdmin = [
  {
    subheader: "Menü",
    items: [
      {
        title: "Anasayfa",
        path: PATH_DASHBOARD.general.app,
        icon: ICONS.dashboard,
      },
      {
        title: "Raporlar",
        path: PATH_DASHBOARD.reports.root,
        icon: ICONS.chat,
        children: [
          {
            title: "Kullanım",
            path: PATH_DASHBOARD.reports.usage,
          },
          {
            title: "İstatistik",
            path: PATH_DASHBOARD.reports.statistic,
          },
          {
            title: "Erişim denetimi",
            path: PATH_DASHBOARD.reports.audit,
          },
        ],
      },
      {
        title: "API Anahtarları",
        path: PATH_DASHBOARD.general.apiKeys,
        icon: ICONS.mail,
      },
    ],
  },
];

const sidebarConfigurator = (isAdmin: boolean) =>
  isAdmin ? sidebarConfigAdmin : sidebarConfigUser;

export default sidebarConfigurator;
